import { useEffect, useState } from "react";
import { resendConfirmationEmail } from "frontend/api";
import style from "./resend-confirmation-email-notification.module.css";
import tracking from "frontend/tracking";

interface ResendConfirmationEmailNotificationProps {
  email: string;
}

export default function ResendConfirmationEmailNotification({ email }: ResendConfirmationEmailNotificationProps) {
  const [confirmationEmailSent, setConfirmationEmailSent] = useState(false);

  function handleResendConfirmationEmail() {
    resendConfirmationEmail();
    tracking.trackAnalyticsEvent("resend_confirmation_email_banner_clicked");
    setConfirmationEmailSent(true);
  }

  useEffect(() => {
    tracking.trackAnalyticsEvent("resend_confirmation_email_banner_shown");
  }, []);

  return (
    <div className={style.toolbar}>
      <span className={style.description}>Please confirm your email address: {email}</span>
      <span onClick={handleResendConfirmationEmail} className={style.link}>
        {confirmationEmailSent ? "Email sent" : "Resend email"}
      </span>
    </div>
  );
}
